import { debounce } from 'lodash'
/**
 * Обработчики событий обновления Store
 * @param {Object} app
 * @param {Object} store
 */
export function initWatcher(app, store) {
  app.$bus.$on('DMS.Analytic.Property.Update', function() {
    store.dispatch('app/analytics/loadPropertiesTree', true)
  })
}



// WEBPACK FOOTER //
// ./src/apps/analytics/store/watcher.js